import {Component} from '@wonderlandengine/api';

/**
 * leaderboard
 */
export class Leaderboard extends Component {
    static TypeName = 'leaderboard';

    start() {
        this.scores = this.object.findByNameRecursive('Scores')[0].getComponent('text');
        this.usernames = this.object
            .findByNameRecursive('Usernames')[0]
            .getComponent('text');
        this.pings = this.object.findByNameRecursive('Pings')[0].getComponent('text');
        this.teamRed = this.object.findByNameRecursive('Team Red')[0].getComponent('text');
        this.teamBlue = this.object
            .findByNameRecursive('Team Blue')[0]
            .getComponent('text');
    }

    updateLeaderboard(leaderboard, teamRed, teamBlue) {
        this.usernames.text = leaderboard.map((e) => e.name).join('\n');
        this.scores.text = leaderboard
            .map((e) => {
                return `${e.tagCount} - ${e.taggedCount} = ${e.score}`;
            })
            .join('\n');
        this.pings.text = leaderboard.map((e) => e.ping?.toString() ?? '?').join('\n');

        this.teamRed.text = teamRed.toString();
        this.teamBlue.text = teamBlue.toString();
    }
}
